'use client';

import type { ReactNode } from 'react';
import { NextIntlClientProvider } from 'next-intl';
import main from '@/messages/fr-FR.json';
import club from '@/messages/club/fr-FR.json';
import federation from '@/messages/federation/fr-FR.json';

// Static imports inside a client module: the bundle ships as a cached JS chunk,
// not as RSC props serialised into every page (see src/i18n/client/index.ts).
const messages = { ...main, ...club, ...federation };

export default function frFRMessages({ children }: { children: ReactNode }) {
  return (
    <NextIntlClientProvider messages={messages} locale="fr-FR" timeZone="Australia/Sydney">
      {children}
    </NextIntlClientProvider>
  );
}
